/**
 * Micheals Infrastructure Advisory - AVA INTELLIGENCE HOOK
 * VERSION: 4.6.1 (Build 2026.07.07 - Polling Refactor)
 * REPLACED: Native WebSocket Implementation with Interval Polling
 */
import { useState, useEffect, useCallback } from 'react';
import { API_BASE } from '../utils/apiClient';

/**
 * useAvaPolling
 * @param {string} endpoint - The specific API route (e.g., '/api/intelligence/status')
 * @param {number} intervalMs - Frequency of polling in milliseconds (default: 5000)
 */
export const useAvaPolling = (endpoint, intervalMs = 5000) => {
    const [data, setData] = useState(null);
    const [isConnected, setIsConnected] = useState(false);
    const [lastUpdated, setLastUpdated] = useState(null);

    const fetchData = useCallback(async () => {
        const sessionId = localStorage.getItem('session_id') || window.__MED_SESSION_ID__;
        
        if (!sessionId) {
            // Silently exit to prevent console spamming
            return;
        }

        try {
            const response = await fetch(`${API_BASE}${endpoint}`, {
                method: 'GET',
                headers: {
                    'x-session-id': sessionId,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`Status: ${response.status}`);
            }

            const result = await response.json();
            
            setData(result);
            setIsConnected(true);
            setLastUpdated(new Date());
        } catch (err) {
            console.error(`❌ [AVA_POLL_FAIL]: ${err.message}`);
            setIsConnected(false);
        }
    }, [endpoint]);

    useEffect(() => {
        // Initial fetch
        fetchData();

        // Setup polling interval
        const intervalId = setInterval(fetchData, intervalMs);

        // Cleanup interval on unmount or endpoint change
        return () => clearInterval(intervalId);
    }, [fetchData, intervalMs]);

    return { 
        data, 
        isConnected, 
        lastUpdated, 
        refresh: fetchData 
    };
};